import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=ba09190c"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../main-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba09190c')) {
      api.createRecord('ba09190c', component.options)
    } else {
      api.reload('ba09190c', component.options)
    }
    module.hot.accept("./Preloader.vue?vue&type=template&id=ba09190c", function () {
      api.rerender('ba09190c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/preloader-component/src/Preloader.vue"
export default component.exports